export const WEBSITE_CDN = '//www.scdn.co/i/_global';
export const CSPZN_ROUTER = 'https://cspzn-router.spotify.net';
export const MESSAGING_ENABLED = true;
export const SUPPORT_SITE_CLIENT_ID = '31a0b2b20718446799a0f6adef1f2892';
export const CHAT_BOT_CLIENT_ID = '85a9fce0c69d4e19966688a92b182051';
export const SUPPORT_EMAIL = 'support@spotify.com';
